import React from 'react';
import PropTypes from 'prop-types';
import themePropTypes from 'core/utils/prop-types/theme';

import withTheme from 'core/hocs/withTheme';
import withBreakpoint from 'core/hocs/withBreakpoint';

import styles from './index.styl';
import Star from './Star';

const Rate = ({ value, max, theme, isMobile }) => {
  const roundedValue = Math.round(value * 2) / 2;
  const fullStars = Math.floor(roundedValue);
  const hasHalf = roundedValue % 1 !== 0;

  const {
    controls: {
      vikontVerdict: {
        score: {
          color: scoreColor,
        },
      },
    },
  } = theme;

  return (
    <div className={styles.scoreDisplay}>
      <style jsx>{`
        .${styles.scoreValue}
          color: ${scoreColor}
      `}</style>
      <div className={styles.scoreValue}>{value?.toString()?.replace('.', ',')}</div>
      <div className={styles.stars}>
        {Array.from({ length: max }, (_, index) => {
          const starIndex = index + 1;
          let fillType = 'empty';

          if (starIndex <= fullStars) {
            fillType = 'full';
          } else if (starIndex === fullStars + 1 && hasHalf) {
            fillType = 'half';
          }

          return (
            <span  className={styles.starWrapper} key={index}>
              <Star
                type={fillType}
                starWidth={isMobile ? 16 : 24}
                starHeight={isMobile ? 16 : 24}
                color={scoreColor}
              />
            </span>
          );
        })}
      </div>
    </div>
  );
};


Rate.defaultProps = {
  max: 5,
};

Rate.propTypes = {
  value: PropTypes.number.isRequired,
  max: PropTypes.number,
  theme: themePropTypes(`{
    controls: {
      vikontVerdict: {
        score: {
          color
        }
      },
    },
  }`),
  isMobile: PropTypes.bool,
};

export default withBreakpoint(withTheme(Rate));
